/**
 * GENERATED by scripts/generate-tabler-subset.js — do not edit by hand.
 *
 * The tabler icons this app can render, so that `TablerIconsModule.pick()`
 * registers 366 icons instead of all 5790. Both the bundle size and the
 * per-instance icon lookup in angular-tabler-icons are proportional to this
 * count — see the header of the generator for the measurements.
 *
 * After adding an `<i-tabler name="...">` or an icon-name literal in
 * TypeScript, run `npm run generate:icons` and commit the result.
 */
import {
  IconAbc,
  IconActivity,
  IconAddressBook,
  IconAffiliate,
  IconAi,
  IconAlertCircle,
  IconAlertOctagon,
  IconAlertTriangle,
  IconAlpha,
  IconApi,
  IconApps,
  IconArchive,
  IconArrowBackUp,
  IconArrowDown,
  IconArrowDownRight,
  IconArrowLeft,
  IconArrowRight,
  IconArrowUp,
  IconArrowUpCircle,
  IconArrowUpRight,
  IconArrowsExchange,
  IconArticle,
  IconAsset,
  IconBadge,
  IconBan,
  IconBell,
  IconBellRinging,
  IconBeta,
  IconBlob,
  IconBlur,
  IconBmp,
  IconBold,
  IconBolt,
  IconBoom,
  IconBrandGithub,
  IconBrandTeams,
  IconBriefcase,
  IconBrowser,
  IconBug,
  IconBuilding,
  IconBuildingBank,
  IconBuildingCommunity,
  IconBuildingOff,
  IconBuildingPlus,
  IconBuildingSkyscraper,
  IconBuildingStore,
  IconBuildings,
  IconCalculator,
  IconCalendar,
  IconCalendarCheck,
  IconCalendarClock,
  IconCalendarEvent,
  IconCalendarMonth,
  IconCalendarPlus,
  IconCalendarStats,
  IconCalendarWeek,
  IconCancel,
  IconCards,
  IconCash,
  IconCategory,
  IconChartBar,
  IconChartBarOff,
  IconChartDonut,
  IconChartDots,
  IconChartLine,
  IconChartPie,
  IconCheck,
  IconCheckbox,
  IconChecklist,
  IconChecks,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconCircle,
  IconCircleCheck,
  IconCircleCheckFilled,
  IconCircleDashed,
  IconCircleDashedX,
  IconCircleDot,
  IconCircleFilled,
  IconCircleX,
  IconClick,
  IconClipboardCheck,
  IconClock,
  IconClockExclamation,
  IconClockHour3,
  IconClockHour4,
  IconCloudDown,
  IconCloudExclamation,
  IconCloudOff,
  IconCloudShare,
  IconCloudUp,
  IconCloudUpload,
  IconCode,
  IconCoin,
  IconColumns,
  IconContainer,
  IconContract,
  IconCopy,
  IconCpu,
  IconCreditCard,
  IconCsv,
  IconCurrency,
  IconCurrencyDollar,
  IconCurrencyEuro,
  IconDashboard,
  IconDatabase,
  IconDatabaseEdit,
  IconDatabaseOff,
  IconDecimal,
  IconDeselect,
  IconDetails,
  IconDeviceDesktop,
  IconDeviceDesktopDown,
  IconDeviceFloppy,
  IconDeviceImacCheck,
  IconDeviceImacX,
  IconDeviceMobile,
  IconDeviceTablet,
  IconDirection,
  IconDirectionSign,
  IconDisabled,
  IconDotsVertical,
  IconDownload,
  IconEdit,
  IconExclamationCircle,
  IconExternalLink,
  IconEye,
  IconEyeOff,
  IconFile,
  IconFileCheck,
  IconFileDescription,
  IconFileDownload,
  IconFileExcel,
  IconFileExport,
  IconFileInvoice,
  IconFileOff,
  IconFilePencil,
  IconFilePlus,
  IconFileSad,
  IconFileSpreadsheet,
  IconFileText,
  IconFileTypeCsv,
  IconFileTypePdf,
  IconFileTypeXls,
  IconFileUpload,
  IconFileZip,
  IconFiles,
  IconFilter,
  IconFilterOff,
  IconFilterX,
  IconFingerprint,
  IconFlag,
  IconFocus,
  IconFolder,
  IconFolderDown,
  IconFolderOpen,
  IconFolderPlus,
  IconFolderSymlink,
  IconFolders,
  IconForms,
  IconFunction,
  IconGauge,
  IconGavel,
  IconGhost,
  IconGif,
  IconGitBranch,
  IconGitMerge,
  IconH1,
  IconH2,
  IconH3,
  IconH4,
  IconH5,
  IconH6,
  IconHandClick,
  IconHandStop,
  IconHash,
  IconHeadphones,
  IconHeartbeat,
  IconHelp,
  IconHelpCircle,
  IconHighlight,
  IconHistory,
  IconHome,
  IconHourglass,
  IconHtml,
  IconId,
  IconIdBadge2,
  IconInbox,
  IconInfoCircle,
  IconInfoTriangle,
  IconInvoice,
  IconItalic,
  IconJpg,
  IconJson,
  IconKey,
  IconLabel,
  IconLanguage,
  IconLayersIntersect,
  IconLayersSubtract,
  IconLayoutDashboard,
  IconLayoutDistributeHorizontal,
  IconLayoutDistributeVertical,
  IconLayoutNavbar,
  IconLayoutSidebar,
  IconLayoutSidebarRight,
  IconLeaf,
  IconLifebuoy,
  IconLine,
  IconLink,
  IconList,
  IconListCheck,
  IconListDetails,
  IconListSearch,
  IconLoader,
  IconLoader2,
  IconLocation,
  IconLocationDollar,
  IconLock,
  IconLockOpen,
  IconLogin,
  IconLogout,
  IconLogs,
  IconMail,
  IconMailCheck,
  IconMailForward,
  IconMailOff,
  IconMailOpened,
  IconMailPlus,
  IconMapPin,
  IconMarkdown,
  IconMars,
  IconMask,
  IconMathFunction,
  IconMaximize,
  IconMenu,
  IconMessage,
  IconMessage2,
  IconMessageChatbot,
  IconMessageCircle,
  IconMinus,
  IconMoodEmpty,
  IconMoon,
  IconNavigation,
  IconNote,
  IconNotes,
  IconNotification,
  IconNumber,
  IconOutbound,
  IconPalette,
  IconPassword,
  IconPdf,
  IconPencil,
  IconPhone,
  IconPhoto,
  IconPin,
  IconPinFilled,
  IconPlaceholder,
  IconPlayerPause,
  IconPlayerPlay,
  IconPlayerSkipBack,
  IconPlayerSkipForward,
  IconPlug,
  IconPlus,
  IconPng,
  IconPointer,
  IconPointerUp,
  IconPresentation,
  IconProgress,
  IconRadar,
  IconRadio,
  IconReceipt,
  IconReceiptDollar,
  IconReceiptRefund,
  IconRefresh,
  IconRefreshAlert,
  IconRepeat,
  IconReport,
  IconReportMoney,
  IconResize,
  IconRestore,
  IconRobot,
  IconRocket,
  IconRosette,
  IconRosetteDiscountCheck,
  IconRosetteDiscountCheckOff,
  IconRotate,
  IconRotateClockwise,
  IconRoute,
  IconRun,
  IconScale,
  IconScan,
  IconScreenshot,
  IconScript,
  IconSearch,
  IconSearchOff,
  IconSection,
  IconSelect,
  IconSend,
  IconSeparator,
  IconServer,
  IconServerOff,
  IconSettings,
  IconShadow,
  IconShadowOff,
  IconShare,
  IconShieldCheck,
  IconShieldLock,
  IconShieldOff,
  IconShieldQuestion,
  IconSignature,
  IconSlideshow,
  IconSpace,
  IconSpaces,
  IconSparkles,
  IconStack2,
  IconStar,
  IconStarHalf,
  IconStarOff,
  IconSun,
  IconSunHigh,
  IconTable,
  IconTableImport,
  IconTableOff,
  IconTag,
  IconTarget,
  IconTax,
  IconTemplate,
  IconTerminal,
  IconTerminal2,
  IconTextDirectionLtr,
  IconTextDirectionRtl,
  IconTicket,
  IconTimeline,
  IconTooltip,
  IconTransfer,
  IconTrash,
  IconTrendingDown,
  IconTrendingUp,
  IconTrophy,
  IconTxt,
  IconUnderline,
  IconUpload,
  IconUrgent,
  IconUser,
  IconUserCheck,
  IconUserCircle,
  IconUserOff,
  IconUserPlus,
  IconUserSearch,
  IconUserShield,
  IconUserStar,
  IconUserX,
  IconUsers,
  IconUsersGroup,
  IconUsersPlus,
  IconVersions,
  IconWallet,
  IconWand,
  IconWashDrycleanOff,
  IconWheel,
  IconWorld,
  IconX,
  IconZip,
  IconZzz,
} from 'angular-tabler-icons/icons';

export const usedTablerIcons = {
  IconAbc,
  IconActivity,
  IconAddressBook,
  IconAffiliate,
  IconAi,
  IconAlertCircle,
  IconAlertOctagon,
  IconAlertTriangle,
  IconAlpha,
  IconApi,
  IconApps,
  IconArchive,
  IconArrowBackUp,
  IconArrowDown,
  IconArrowDownRight,
  IconArrowLeft,
  IconArrowRight,
  IconArrowUp,
  IconArrowUpCircle,
  IconArrowUpRight,
  IconArrowsExchange,
  IconArticle,
  IconAsset,
  IconBadge,
  IconBan,
  IconBell,
  IconBellRinging,
  IconBeta,
  IconBlob,
  IconBlur,
  IconBmp,
  IconBold,
  IconBolt,
  IconBoom,
  IconBrandGithub,
  IconBrandTeams,
  IconBriefcase,
  IconBrowser,
  IconBug,
  IconBuilding,
  IconBuildingBank,
  IconBuildingCommunity,
  IconBuildingOff,
  IconBuildingPlus,
  IconBuildingSkyscraper,
  IconBuildingStore,
  IconBuildings,
  IconCalculator,
  IconCalendar,
  IconCalendarCheck,
  IconCalendarClock,
  IconCalendarEvent,
  IconCalendarMonth,
  IconCalendarPlus,
  IconCalendarStats,
  IconCalendarWeek,
  IconCancel,
  IconCards,
  IconCash,
  IconCategory,
  IconChartBar,
  IconChartBarOff,
  IconChartDonut,
  IconChartDots,
  IconChartLine,
  IconChartPie,
  IconCheck,
  IconCheckbox,
  IconChecklist,
  IconChecks,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconCircle,
  IconCircleCheck,
  IconCircleCheckFilled,
  IconCircleDashed,
  IconCircleDashedX,
  IconCircleDot,
  IconCircleFilled,
  IconCircleX,
  IconClick,
  IconClipboardCheck,
  IconClock,
  IconClockExclamation,
  IconClockHour3,
  IconClockHour4,
  IconCloudDown,
  IconCloudExclamation,
  IconCloudOff,
  IconCloudShare,
  IconCloudUp,
  IconCloudUpload,
  IconCode,
  IconCoin,
  IconColumns,
  IconContainer,
  IconContract,
  IconCopy,
  IconCpu,
  IconCreditCard,
  IconCsv,
  IconCurrency,
  IconCurrencyDollar,
  IconCurrencyEuro,
  IconDashboard,
  IconDatabase,
  IconDatabaseEdit,
  IconDatabaseOff,
  IconDecimal,
  IconDeselect,
  IconDetails,
  IconDeviceDesktop,
  IconDeviceDesktopDown,
  IconDeviceFloppy,
  IconDeviceImacCheck,
  IconDeviceImacX,
  IconDeviceMobile,
  IconDeviceTablet,
  IconDirection,
  IconDirectionSign,
  IconDisabled,
  IconDotsVertical,
  IconDownload,
  IconEdit,
  IconExclamationCircle,
  IconExternalLink,
  IconEye,
  IconEyeOff,
  IconFile,
  IconFileCheck,
  IconFileDescription,
  IconFileDownload,
  IconFileExcel,
  IconFileExport,
  IconFileInvoice,
  IconFileOff,
  IconFilePencil,
  IconFilePlus,
  IconFileSad,
  IconFileSpreadsheet,
  IconFileText,
  IconFileTypeCsv,
  IconFileTypePdf,
  IconFileTypeXls,
  IconFileUpload,
  IconFileZip,
  IconFiles,
  IconFilter,
  IconFilterOff,
  IconFilterX,
  IconFingerprint,
  IconFlag,
  IconFocus,
  IconFolder,
  IconFolderDown,
  IconFolderOpen,
  IconFolderPlus,
  IconFolderSymlink,
  IconFolders,
  IconForms,
  IconFunction,
  IconGauge,
  IconGavel,
  IconGhost,
  IconGif,
  IconGitBranch,
  IconGitMerge,
  IconH1,
  IconH2,
  IconH3,
  IconH4,
  IconH5,
  IconH6,
  IconHandClick,
  IconHandStop,
  IconHash,
  IconHeadphones,
  IconHeartbeat,
  IconHelp,
  IconHelpCircle,
  IconHighlight,
  IconHistory,
  IconHome,
  IconHourglass,
  IconHtml,
  IconId,
  IconIdBadge2,
  IconInbox,
  IconInfoCircle,
  IconInfoTriangle,
  IconInvoice,
  IconItalic,
  IconJpg,
  IconJson,
  IconKey,
  IconLabel,
  IconLanguage,
  IconLayersIntersect,
  IconLayersSubtract,
  IconLayoutDashboard,
  IconLayoutDistributeHorizontal,
  IconLayoutDistributeVertical,
  IconLayoutNavbar,
  IconLayoutSidebar,
  IconLayoutSidebarRight,
  IconLeaf,
  IconLifebuoy,
  IconLine,
  IconLink,
  IconList,
  IconListCheck,
  IconListDetails,
  IconListSearch,
  IconLoader,
  IconLoader2,
  IconLocation,
  IconLocationDollar,
  IconLock,
  IconLockOpen,
  IconLogin,
  IconLogout,
  IconLogs,
  IconMail,
  IconMailCheck,
  IconMailForward,
  IconMailOff,
  IconMailOpened,
  IconMailPlus,
  IconMapPin,
  IconMarkdown,
  IconMars,
  IconMask,
  IconMathFunction,
  IconMaximize,
  IconMenu,
  IconMessage,
  IconMessage2,
  IconMessageChatbot,
  IconMessageCircle,
  IconMinus,
  IconMoodEmpty,
  IconMoon,
  IconNavigation,
  IconNote,
  IconNotes,
  IconNotification,
  IconNumber,
  IconOutbound,
  IconPalette,
  IconPassword,
  IconPdf,
  IconPencil,
  IconPhone,
  IconPhoto,
  IconPin,
  IconPinFilled,
  IconPlaceholder,
  IconPlayerPause,
  IconPlayerPlay,
  IconPlayerSkipBack,
  IconPlayerSkipForward,
  IconPlug,
  IconPlus,
  IconPng,
  IconPointer,
  IconPointerUp,
  IconPresentation,
  IconProgress,
  IconRadar,
  IconRadio,
  IconReceipt,
  IconReceiptDollar,
  IconReceiptRefund,
  IconRefresh,
  IconRefreshAlert,
  IconRepeat,
  IconReport,
  IconReportMoney,
  IconResize,
  IconRestore,
  IconRobot,
  IconRocket,
  IconRosette,
  IconRosetteDiscountCheck,
  IconRosetteDiscountCheckOff,
  IconRotate,
  IconRotateClockwise,
  IconRoute,
  IconRun,
  IconScale,
  IconScan,
  IconScreenshot,
  IconScript,
  IconSearch,
  IconSearchOff,
  IconSection,
  IconSelect,
  IconSend,
  IconSeparator,
  IconServer,
  IconServerOff,
  IconSettings,
  IconShadow,
  IconShadowOff,
  IconShare,
  IconShieldCheck,
  IconShieldLock,
  IconShieldOff,
  IconShieldQuestion,
  IconSignature,
  IconSlideshow,
  IconSpace,
  IconSpaces,
  IconSparkles,
  IconStack2,
  IconStar,
  IconStarHalf,
  IconStarOff,
  IconSun,
  IconSunHigh,
  IconTable,
  IconTableImport,
  IconTableOff,
  IconTag,
  IconTarget,
  IconTax,
  IconTemplate,
  IconTerminal,
  IconTerminal2,
  IconTextDirectionLtr,
  IconTextDirectionRtl,
  IconTicket,
  IconTimeline,
  IconTooltip,
  IconTransfer,
  IconTrash,
  IconTrendingDown,
  IconTrendingUp,
  IconTrophy,
  IconTxt,
  IconUnderline,
  IconUpload,
  IconUrgent,
  IconUser,
  IconUserCheck,
  IconUserCircle,
  IconUserOff,
  IconUserPlus,
  IconUserSearch,
  IconUserShield,
  IconUserStar,
  IconUserX,
  IconUsers,
  IconUsersGroup,
  IconUsersPlus,
  IconVersions,
  IconWallet,
  IconWand,
  IconWashDrycleanOff,
  IconWheel,
  IconWorld,
  IconX,
  IconZip,
  IconZzz,
};
